import { Quote } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

const QUOTES = [
  {
    text: "STAX turned our boring brand into something people actually talk about. The new identity paid for itself in a month.",
    name: "Maya R.", role: "Owner, Lumen & Co. Coffee", big: true,
  },
  {
    text: "Our website finally feels like us — and the booking numbers prove it works.",
    name: "Dre W.", role: "Pulse Athletics",
  },
  {
    text: "The print pieces are so good our customers refuse to throw them away.",
    name: "Sam T.", role: "Field Notes Market",
  },
];

export const Testimonials = ({ ch = "05" }) => (
  <section data-testid="testimonials-section" className="relative overflow-hidden bg-staxmagenta py-24 sm:py-32 border-y-4 border-ink">
    <div className="ink-dot absolute -left-28 -top-28 h-96 w-96 bg-staxyellow" />
    <div className="ink-dot absolute -right-24 bottom-0 h-80 w-80 bg-staxcyan" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal><SectionTag color="bg-white text-ink" ch={ch}>Testimonials</SectionTag></Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 font-display uppercase leading-[0.92] text-4xl sm:text-5xl lg:text-6xl text-white">
          Good design speaks<br />for itself<span className="text-staxyellow">.</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal delay={0.1} className="lg:col-span-7">
          <figure data-testid="testimonial-featured" className="relative h-full border-4 border-ink bg-white p-8 sm:p-12 shadow-hard">
            <Quote size={56} className="text-staxmagenta" fill="var(--sm)" />
            <blockquote className="mt-6 font-display uppercase leading-[1.05] text-2xl sm:text-4xl text-ink">
              "{QUOTES[0].text}"
            </blockquote>
            <figcaption className="mt-8 font-mono2 text-xs font-bold uppercase tracking-[0.25em] text-ink/60">
              {QUOTES[0].name} — {QUOTES[0].role}
            </figcaption>
          </figure>
        </Reveal>
        <div className="lg:col-span-5 flex flex-col gap-6">
          {QUOTES.slice(1).map((q, i) => (
            <Reveal key={q.name} delay={0.18 + i * 0.08} className="flex-1">
              <figure data-testid={`testimonial-${i + 1}`} className="relative h-full border-4 border-ink bg-ink p-7 shadow-hard-sm">
                <span className="absolute -top-3 -right-3 h-10 w-10 rounded-full bg-staxyellow border-2 border-ink" />
                <blockquote className="font-body text-base sm:text-lg font-medium leading-relaxed text-white">
                  "{q.text}"
                </blockquote>
                <figcaption className="mt-5 font-mono2 text-[11px] font-bold uppercase tracking-[0.25em] text-staxyellow">
                  {q.name} — {q.role}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
